<template>
  <el-select
    v-model="selectedVal"
    @change="change"
    :filterable="properties.filterable"
    :disabled="!(properties.opts && properties.opts.length)"
    :clearable="properties.clearable"
    :placeholder="properties.placeholder"
    :multiple="properties.multi"
    :collapse-tags="properties.multi"
    :collapse-tags-tooltip="properties.multi"
    :max-collapse-tags="1"
    :ref="`${properties.filterName}_select_filter`"
    style="width: 100%;">
    <el-option
      v-for="(o, i) in properties.opts"
      :key="i"
      :label="o.label"
      :value="o.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'selectFilter',
  props: {
    properties: Object
  },
  data () {
    return {
      selectedVal: ''
    }
  },
  methods: {
    change () {
      if (typeof this.properties.sync === 'function') {
        this.properties.sync(this.properties.filterName, this.selectedVal)
        if (this.properties.applyOnSelection) {
          this.properties.apply()
        }
      }
    },
    setDefaults () {
      const { defaults, opts } = this.properties
      if (defaults && Array.isArray(defaults) && defaults.length) {
        const allowed = opts.map(opt => opt.value)
        // Check if all defaults are in the allowed options
        if (defaults.every(v => allowed.includes(v))) {
          this.selectedVal = defaults.length === 1 ? defaults[0] : defaults
          this.change()
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.properties.defaults) {
        this.setDefaults()
      }
    })
  },
  watch: {
    'properties.defaults': {
      handler (newDefaults, oldDefaults) {
        // Check if the defaults have changed before updating selectedVal
        if (JSON.stringify(newDefaults) !== JSON.stringify(oldDefaults)) {
          if (Array.isArray(newDefaults)) {
            this.selectedVal = newDefaults.length > 0 ? newDefaults : '' // Default to empty if it's empty
            this.change() // Sync back to Vuex if needed
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style>
.hidden-scrollbar::-webkit-scrollbar {
  height: 0;
  width: 0;
}
</style>
